export function obtenerFecha() {
  const fecha = new Date();
  const dia = String(fecha.getDate()).padStart(2, "0");
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const año = fecha.getFullYear();
  let hora = fecha.getHours();
  const minutos = String(fecha.getMinutes()).padStart(2, "0");
  const segundos = String(fecha.getSeconds()).padStart(2, "0");
  let periodo = "a. m.";

  // Cambiar a "p. m." si es tarde
  if (hora >= 12) {
    periodo = "p. m.";
    if (hora > 12) {
      hora -= 12;
    }
  }

  const fechaConFormato = `${dia}/${mes}/${año} ${hora}:${minutos}:${segundos} ${periodo}`;
  return fechaConFormato;
}

// Función para obtener la fecha actual en formato YYYY-MM-DD
export function obtenerFechaActual() {
  const fecha = new Date();
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript empiezan en 0
  const ano = fecha.getFullYear();

  return `${ano}-${mes}-${dia}`;
}

// Función para obtener la hora actual en formato h:mm a.m./p.m.
export function obtenerHoraActual() {
  const fecha = new Date();
  const horas = fecha.getHours();
  const minutos = String(fecha.getMinutes()).padStart(2, '0');
  const ampm = horas >= 12 ? 'p.m.' : 'a.m.';

  return `${horas % 12 || 12}:${minutos} ${ampm}`;
}

export function capitalizarTexto(texto) {
  return texto.toLowerCase().replace(/(?:^|\s)\w/g, function (letra) {
    return letra.toUpperCase();
  });
}

/*
  Función para para hacer scroll hasta el input que tenga el nombre de la etiqueta
  @param {string} tagName - Nombre de la etiqueta del input
  @param {string} placeholder - Mensaje que se mostrará en el input
*/
export const scrollToInput = (tagName = "", placeholder = "Por favor ingrese un valor válido") => {
  const input = document.getElementsByName(tagName)[0];
  input.classList.add("input-error");

  const label = input.nextElementSibling;
  if (label && label.classList.contains("span-md")) {
    label.classList.add("label-error");
    const labelNoData = label.nextElementSibling;
    if (labelNoData) labelNoData.classList.add("label-error");
  }

  if (input.tagName === "INPUT") {
    input.placeholder = placeholder;
  }

  input.scrollIntoView({ behavior: "smooth" });
  input.focus();
};


export const decodeToNumber = (hexString) => {
  var idNumber = parseInt(hexString, 16);
  return idNumber.toString();
};

export const tratoCliente = (tratamiento) => {
  switch (tratamiento) {
    case "Sr":
      return "Estimado";
    case "Sra":
      return "Estimada";
    case "Srita":
      return "Estimada";
    default:
      return "Estimado/a";
  }
}

export const tratoClienteConcesionaria = (tratamiento) => {
  if (tratamiento === "") {
    return "Sin seleccionar.";
  }
  return `${tratamiento}.`;
}

export const dateWithTimeZone = () => {
  return new Date(new Date().toLocaleString("en-US", {timeZone: process.env.REACT_APP_TIMEZONE}));
}

/**
 * 
 * @param {[*]} concesionarias 
 * @returns 
 */
export const getOnlyAudiCenters = (concesionarias = [], servicenter) => {
  const dealers =  concesionarias.filter(concesionaria => {
    const name = concesionaria.name.toLowerCase().trim();

    if (servicenter) {
      return name.startsWith("audi center") || name.startsWith(servicenter.toLowerCase().trim()); 
    }

    // TODO: Remover condicion 'autos alemanes' cuando se tenga el nombre correcto para el dealer 151
     return name.startsWith("audi center") || concesionaria.dealerNumber === 151;
  });

  return dealers.map(dealer => {
    dealer.name = dealer.name.toUpperCase().trim();

    if (dealer.name[dealer.name.length - 1] === ".") {
      dealer.name = dealer.name.slice(0, dealer.name.length - 1);
    }

    if (dealer.dealerNumber === 151) {
      dealer.name = "AUDI CENTER AGUASCALIENTES";
    }

    return dealer;
  });
}